import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <div className="pt-20 pb-10 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <div className="mt-6">
              <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
                关于红桃影院
              </h1>
              <p className="text-foreground-500 mt-2 text-sm">了解我们的品牌故事与使命</p>
            </div>
          </div>
        </div>

        <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
              <div className="lg:col-span-2">
                <div className="aspect-square rounded-2xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20modern%20cinema%20brand%20visual%20identity%2C%20warm%20crimson%20and%20gold%20abstract%20geometric%20design%2C%20luxurious%20theater%20curtain%20motif%2C%20minimalist%20sophisticated%20brand%20aesthetic%2C%20soft%20gradient%20lighting%2C%20premium%20entertainment%20brand%20feel&width=600&height=600&seq=about-brand-image&orientation=squarish"
                    alt="红桃影院品牌形象"
                    title="红桃影院品牌视觉"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="lg:col-span-3">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
                  品牌简介
                </h2>
                <div className="text-foreground-700 leading-relaxed space-y-4">
                  <p>
                    红桃影院成立于2020年，是一家专注于在线电视剧资源聚合与推荐的流媒体平台。我们致力于为中国乃至全球的华语追剧爱好者提供<strong>高质量、免费、便捷</strong>的在线电视剧观看服务。
                  </p>
                  <p>
                    自创立以来，红桃影院始终秉持"让每个人都能免费看好剧"的理念，汇聚了来自中国大陆、韩国、美国、日本等多个国家和地区的<strong>优质电视剧资源</strong>。从热播国产剧到高分韩剧，从经典美剧到小众日剧，红桃影院为您一网打尽。
                  </p>
                  <p>
                    我们拥有一支专业的影视内容编辑团队，每日追踪全球最新电视剧动态，确保您能第一时间获取<strong>最新电视剧上线信息</strong>。无论是正在热播的新剧，还是值得回味的经典老剧，红桃影院都能为您提供优质的在线观看体验。
                  </p>
                  <p>
                    红桃影院，您的专属<strong>免费追剧平台</strong>。随时随地，享受高清流畅的观剧体验。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                品牌口碑
              </h2>
              <p className="text-sm text-foreground-500 mt-2">来自用户们的真实评价</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  name: '追剧达人小王',
                  rating: 5,
                  text: '红桃影院真的是我每天都在用的追剧平台！更新速度超快，画质也很清晰。国产剧和韩剧的资源特别全，强烈推荐给所有喜欢追剧的朋友！',
                },
                {
                  name: '影视爱好者小李',
                  rating: 5,
                  text: '用了这么久，红桃影院的体验一直很稳定。界面简洁好用，搜索功能也很方便。最重要的是完全免费，对于我这种重度追剧用户来说简直太友好了。',
                },
                {
                  name: '韩剧迷小张',
                  rating: 5,
                  text: '作为一个韩剧爱好者，红桃影院的韩剧资源让我非常满意。《眼泪女王》《黑暗荣耀》这些热门韩剧都能第一时间看到更新，翻译质量也很高。',
                },
                {
                  name: '家庭观众老刘',
                  rating: 5,
                  text: '红桃影院的国产剧资源非常丰富，我和家人每天晚上都会在这里找剧看。从古装到现代，各种类型都有，而且不需要注册付费，很方便。',
                },
                {
                  name: '美剧粉小陈',
                  rating: 4,
                  text: '美剧的资源虽然不是最多的，但质量都很高。《最后生还者》这种高分剧集都有全集资源，画质也很棒。希望以后能上更多美剧！',
                },
                {
                  name: '日剧控小林',
                  rating: 5,
                  text: '红桃影院的日剧分类做得很好，找剧非常方便。《怪物》这部日剧在别的地方找了很久都没找到全集，红桃影院居然有！真的太惊喜了。',
                },
              ].map((review, index) => (
                <div key={index} className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                  <div className="flex items-center gap-0.5 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-sm ${i < review.rating ? 'text-accent-500' : 'text-foreground-200'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">{review.text}</p>
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs font-semibold text-primary-600">{review.name[0]}</span>
                    </div>
                    <span className="text-sm font-medium text-foreground-900">{review.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                联系我们
              </h2>
              <p className="text-sm text-foreground-500 mt-2">有任何问题或建议，欢迎与我们联系</p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-6">联系方式</h3>
                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-none">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">邮箱</p>
                      <p className="text-sm text-foreground-500">contact@hongtao.tv</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-none">
                      <i className="ri-phone-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">电话</p>
                      <p className="text-sm text-foreground-500">400-888-6666</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-none">
                      <i className="ri-map-pin-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">地址</p>
                      <p className="text-sm text-foreground-500">北京市朝阳区影视产业园区A座15层</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-none">
                      <i className="ri-time-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">工作时间</p>
                      <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>

                <div className="mt-8">
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-4">关注我们</h3>
                  <div className="flex items-center gap-3">
                    <a href="#" className="w-10 h-10 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-white transition-all" rel="nofollow">
                      <i className="ri-wechat-line"></i>
                    </a>
                    <a href="#" className="w-10 h-10 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-white transition-all" rel="nofollow">
                      <i className="ri-weibo-line"></i>
                    </a>
                    <a href="#" className="w-10 h-10 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-white transition-all" rel="nofollow">
                      <i className="ri-bilibili-line"></i>
                    </a>
                    <a href="#" className="w-10 h-10 rounded-full bg-background-100 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-white transition-all" rel="nofollow">
                      <i className="ri-links-line"></i>
                    </a>
                  </div>
                </div>
              </div>

              <div>
                <div className="bg-background-100 rounded-2xl p-8 border border-background-200/70">
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-6">发送消息</h3>
                  <form className="space-y-4" data-readdy-form action="https://readdy.ai/api/form/d9nfggkit35ii3jdlqng" method="POST">
                    <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                        <input
                          type="text"
                          name="name"
                          required
                          className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                        <input
                          type="email"
                          name="email"
                          required
                          className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground-700 mb-1.5">主题</label>
                      <input
                        type="text"
                        name="subject"
                        required
                        className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all"
                        placeholder="请输入主题"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-foreground-700 mb-1.5">消息内容</label>
                      <textarea
                        name="message"
                        rows={4}
                        maxLength={500}
                        required
                        className="w-full px-4 py-2.5 bg-background-50 border border-background-200 rounded-lg text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                        placeholder="请输入您的消息（500字以内）"
                      ></textarea>
                    </div>
                    <button
                      type="submit"
                      className="w-full px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
                    >
                      发送消息
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                发展历程
              </h2>
              <p className="text-sm text-foreground-500 mt-2">红桃影院的成长之路</p>
            </div>

            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
              <div className="space-y-10">
                {[
                  { year: '2020', title: '品牌创立', desc: '红桃影院正式成立，团队核心成员来自国内顶级视频平台，以"免费追剧"为初心，正式进入在线影视领域。' },
                  { year: '2021', title: '资源扩展', desc: '平台资源库突破1000部电视剧，覆盖国产剧、韩剧、美剧三大品类，日活跃用户突破10万。' },
                  { year: '2022', title: '体验升级', desc: '全面升级播放技术，支持1080P与4K超清画质。新增日剧频道，内容品类进一步丰富。' },
                  { year: '2023', title: '高速成长', desc: '资源库突破3000部，月活跃用户突破500万。推出智能推荐算法，为用户精准匹配喜爱的剧集。' },
                  { year: '2024', title: '行业领先', desc: '资源总量突破5000部，成为国内领先的免费电视剧在线观看平台。持续优化观影体验，服务更多追剧爱好者。' },
                ].map((milestone, index) => (
                  <div key={index} className="relative flex flex-col md:flex-row gap-6 md:gap-0">
                    <div className={`md:w-1/2 md:text-right ${index % 2 === 0 ? 'md:pr-14' : 'md:order-2 md:pl-14'}`}>
                      {index % 2 === 0 && (
                        <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                          <span className="text-sm font-bold text-primary-600">{milestone.year}</span>
                          <h3 className="text-base font-heading font-semibold text-foreground-900 mt-1">{milestone.title}</h3>
                          <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{milestone.desc}</p>
                        </div>
                      )}
                    </div>

                    <div className="absolute left-4 md:left-1/2 top-6 md:top-6 w-3 h-3 rounded-full bg-primary-500 md:-translate-x-1.5 z-10"></div>

                    <div className={`md:w-1/2 ${index % 2 !== 0 ? 'md:pr-14' : 'md:order-2 md:pl-14'}`}>
                      {index % 2 !== 0 && (
                        <div className="bg-background-50 rounded-xl p-5 border border-background-200/70">
                          <span className="text-sm font-bold text-primary-600">{milestone.year}</span>
                          <h3 className="text-base font-heading font-semibold text-foreground-900 mt-1">{milestone.title}</h3>
                          <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{milestone.desc}</p>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于红桃影院',
          description: '红桃影院成立于2020年，是一家专注于在线电视剧资源聚合与推荐的流媒体平台，提供高质量免费在线电视剧观看服务。',
          url: 'https://hongtao.tv/about',
          isPartOf: { '@type': 'WebSite', name: '红桃影院', url: 'https://hongtao.tv' },
          about: {
            '@type': 'Organization',
            name: '红桃影院',
            url: 'https://hongtao.tv',
            description: '红桃影视为您汇聚电视剧全集免费资源，最新电视剧、热播剧集同步更新。',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-6666',
              email: 'contact@hongtao.tv',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              addressCountry: 'CN',
              streetAddress: '影视产业园区A座15层',
            },
          },
        })}
      </script>
    </>
  );
}